import { init as initApm } from "@elastic/apm-rum";

const active = process.env.REACT_APP_APM_ACTIVE === "true";
const serverUrl = process.env.REACT_APP_APM_SERVER_URL;
const serviceName = process.env.REACT_APP_APM_SERVICE_NAME ?? "osc-web";
const environment = process.env.REACT_APP_APM_ENVIRONMENT ?? "unknown";

const distributedTracingOrigins = [
    process.env.REACT_APP_API_OSCI,
    process.env.REACT_APP_API_PTL_COMN,
].filter((origin): origin is string => Boolean(origin));

const apm =
    active && serverUrl
        ? initApm({
              serviceName,
              serverUrl,
              environment,
              distributedTracingOrigins,
          })
        : null;

export { apm };
